import { render, staticRenderFns } from "./ClosedTill.vue?vue&type=template&id=0cd633ad&scoped=true&"
import script from "./ClosedTill.vue?vue&type=script&lang=js&"
export * from "./ClosedTill.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTill.vue?vue&type=style&index=0&id=0cd633ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd633ad",
  null
  
)

export default component.exports